module.exports = __webpack_public_path__ + "9cee7510acd35b67fa0972fcca72b421.jpg";